module.exports = __webpack_public_path__ + "img/p9.ba9bffee.png";